import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavLink } from "react-router-dom";
import { useContext } from "react";
import MenuContext from "../../Context/MenuContext";
import windowSize from "../../Context/WindowContext";
import { useCurrentUser } from "../../Context/CurrentUserContext";
import { useLanguage } from "../../Context/LanguageContext";
import { links } from "./NavLinks";

export default function SideBar ()
{
    const Menue = useContext( MenuContext );
    const WindowContext = useContext( windowSize );
    const WindowSize = WindowContext.WindowSize;
    const menuisopen = Menue.menuisopen;
    const { t } = useLanguage();

    const { user } = useCurrentUser(); // بيانات المستخدم جايه من RequierAuth، من غير طلب تاني

    if ( !user ) return null; // لسه البيانات ما جهزتش من الحارس

    return (
        <div
            className="side-bar"
            style={ {
                left: WindowSize < "768" ? ( menuisopen ? 0 : "-100%" ) : 0,
                width: menuisopen ? "300px" : "fit-content",
                transition: "left 0.3s ease, width 0.3s ease",
                position: WindowSize < "768" ? "fixed" : "sticky",
            } }
        >
            { links.map( ( link, key ) => (
                link.role.includes( user.role ) && (
                    <NavLink
                        key={ key }
                        to={ link.path }
                        className="d-flex align-items-center gap-2 sid-bar-link mt-2"
                    >
                        <FontAwesomeIcon
                            icon={ link.icon }
                            style={ { padding: menuisopen ? "10px 8px 10px 15px" : "10px 14px" } }
                        />
                        <p className="m-0" style={ { display: menuisopen ? "block" : "none" } }>
                            { t( `dashboardNav.${ link.translationKey }` ) }
                        </p>
                    </NavLink>
                )
            ) ) }
        </div>
    );
}
